import { StrictMode, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'

export function mount(id: string, node: ReactNode) {
  const el = document.getElementById(id)
  if (!el) {
    throw new Error(`Mount element #${id} was not found.`)
  }
  createRoot(el).render(<StrictMode>{node}</StrictMode>)
}
